<template>
  <NavBar/>
      <section class="projects min-vh-100 mx-auto pt-5" >
        <div class="heading text-center pt-5">
            <h2>Projects</h2>
        </div>
        <div class="row mx-auto justify-content-center align-items-center text-center">
            <div v-for="category in categories" :key="category.name"
             class="category-container col-lg-2 col-md-6 m-2 pt-3">
                <router-link :to="{ name: 'ProjectContents', params: { id: category.name}}" class="card category mx-auto">
                    <img :src="category.img" class="card-img-top" alt="img here">
                    <div class="card-body py-0 px-0">
                    <h4 class="card-title">{{ category.name }}</h4>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row mx-auto justify-content-center align-items-center text-center pb-5">
        </div>
    </section>
  <Footer/>
</template>

<script>
import { ref } from '@vue/reactivity'
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
    components: {
        NavBar,
        Footer
    },
    setup(){
        document.title = 'Soncraft - Projects'
        
        const categories = ref([
            { name: 'java', img: require('@/assets/java.png') },
            { name: 'c#', img: require('@/assets/csharp.png') },
            { name: 'python', img: require('@/assets/python.png') },
            { name: 'android', img: require('@/assets/android.png') },
            { name: 'arduino', img: require('@/assets/arduino.png') },
            { name: 'unity', img: require('@/assets/unity.png') },
            { name: 'godot', img: require('@/assets/godot.png') },
            { name: 'blender', img: require('@/assets/blender.png') }
        ])
        
        return{
            categories
        }
    }
}
</script>

<style>
.projects a{
    text-decoration: none;
}
.projects .heading h2{
    color: #fff;
    font-size: 200%;
}
.projects .row{
    width: 60%;
}
.projects .card-img-top{
    pointer-events: none;
    padding: 0.5rem;
}
.projects .card-title{
    color: #808080;
    text-transform: capitalize;
}
.projects .category-container{
    width: 10rem;
    height: 12rem;
    padding: 0;
}
.projects .category{
    width: 9rem;
    height: 12rem;
    background-color: #000;
}
.projects .category:hover > .card-img-top{
    padding: .1rem;
}
.projects .category:hover >.card-body h4{
    color: #fff;
}
@media screen and (max-width: 900px){
    .projects .row{
      width: 100%;
  }
  .projects .category-container{
      width: 8.5rem;
      height: 9.5rem;
  }
  .projects .category{
    width: 8rem;
    height: 9.5rem;
  }
  .projects .category .card-title{
    font-size: 1.2rem;
  }
}
</style>